var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExactPayGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(70.980392%,71.764706%,77.647059%)",
      fillOpacity: 1
    },
    d: "M 2.34375 0 L 13.675781 0 C 14.964844 0 16.019531 1.054688 16.019531 2.34375 L 16.019531 4.109375 L 9.25 4.109375 C 9.25 4.445312 9.109375 4.75 8.878906 4.972656 C 8.652344 5.191406 8.339844 5.328125 7.992188 5.328125 C 7.648438 5.328125 7.332031 5.191406 7.105469 4.972656 C 6.878906 4.75 6.738281 4.445312 6.738281 4.109375 L 0 4.109375 L 0 2.34375 C 0 1.054688 1.054688 0 2.34375 0 Z M 2.34375 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(70.980392%,71.764706%,77.647059%)",
      fillOpacity: 1
    },
    d: "M 9.773438 4.992188 L 16.019531 4.992188 L 16.019531 9.644531 C 16.019531 10.933594 14.964844 11.988281 13.675781 11.988281 L 2.34375 11.988281 C 1.054688 11.988281 0 10.933594 0 9.644531 L 0 4.992188 L 6.214844 4.992188 C 6.308594 5.25 6.460938 5.480469 6.65625 5.671875 C 7 6.003906 7.472656 6.210938 7.992188 6.210938 C 8.515625 6.210938 8.988281 6.003906 9.332031 5.671875 C 9.527344 5.480469 9.679688 5.25 9.773438 4.992188 Z M 9.773438 4.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12.550781 7.359375 C 13.382812 7.359375 14.054688 8.03125 14.054688 8.859375 C 14.054688 9.691406 13.382812 10.363281 12.550781 10.363281 C 11.722656 10.363281 11.050781 9.691406 11.050781 8.859375 C 11.050781 8.03125 11.722656 7.359375 12.550781 7.359375 Z M 12.550781 7.359375 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExactPayGray);
export default __webpack_public_path__ + "static/media/exact-pay-gray.cda6b22dcee2747692d8b63066432ac9.svg";
export { ForwardRef as ReactComponent };